import React, { useState } from 'react';
import classNames from 'classnames';
import { Popover } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { compose } from '@/utils/story-composer';
import LinkComponent, { getLinkPath } from '@/components/elements/link-component';

function NavigationCategory({ elementProps, name, items, pageContext, link, excludedLocales = [] }) {
	const { i18n } = useTranslation();
	const isExcludedLocale = excludedLocales.includes(i18n.language);

	if (isExcludedLocale) {
		return null;
	}

	const [isShowing, setIsShowing] = useState(false);
	const { location } = pageContext;

	const currentPath = `${process.env.GATSBY_DOMAIN_URL || ''}${location.pathname}`;

	const linksInMenu = [link, ...items.map(item => item.props.blok.link)];
	const urlsInMenu = linksInMenu.map(link => getLinkPath(link, true));
	const shouldUnderline = urlsInMenu.some(url => currentPath.includes(url));

	const renderLink = () =>
		link.url || link.cached_url ? (
			<LinkComponent
				link={link}
				appearance={`mx-5 group bg-white rounded-md inline-flex items-center text-base font-semibold text-midnight hover:text-riverbed self-center h-full underline-offset-4 ${
					shouldUnderline || isShowing ? 'underline' : 'hover:underline'
				}`}
			>
				{name}
			</LinkComponent>
		) : (
			<span className="mx-5 font-semibold">{name}</span>
		);

	if (pageContext.place === 'top') {
		return (items && items.length !== 0) || (typeof items === 'object' && !Array.isArray(items)) ? (
			<Popover {...elementProps} className="relative">
				{({ open }) => (
					<>
						<div onMouseEnter={() => setIsShowing(true)} onMouseLeave={() => setIsShowing(false)}>
							<Popover.Button className={classNames(open ? 'text-midnight font-bold' : 'text-midnight')}>
								{renderLink()}
							</Popover.Button>
						</div>
						<div
							onMouseEnter={() => setIsShowing(true)}
							onMouseLeave={() => setIsShowing(false)}
							className={classNames(
								isShowing ? 'absolute' : 'hidden',
								'z-10 left-1/2 transform -translate-x-1/2 pt-3 w-110 rounded-xl'
							)}
						>
							<div className="rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
								<ul className="relative py-4">{items}</ul>
							</div>
						</div>
					</>
				)}
			</Popover>
		) : (
			<div className="text-midnight">{renderLink()}</div>
		);
	}

	return (
		<div className="lg:hidden min-h-10">
			{link ? (
				<LinkComponent
					link={link}
					appearance={`mx-5 font-semibold text-midnight hover:text-riverbed underline-offset-4 ${
						shouldUnderline ? 'underline' : ''
					}`}
				>
					{name}
				</LinkComponent>
			) : (
				<span className="mx-5 font-semibold text-midnight">{name}</span>
			)}

			<ul className="relative mt-2">{items}</ul>
		</div>
	);
}

export default NavigationCategory;

compose('navigation-category', NavigationCategory, { children: ['items'] });
